var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgBacki = function SvgBacki(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z",
    "data-name": "Trigger Area"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: props.color || 'currentColor',
    strokeLinecap: "round",
    strokeWidth: 1.6,
    d: "M18 12H6",
    "data-name": "Line 89"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: props.color || 'currentColor',
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6,
    d: "m11 6.996-5 5 5 5",
    "data-name": "Path 4555"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBacki);
export default ForwardRef;